export default __webpack_public_path__ + "static/media/canada.feb2d5e1.png";